import { useRef } from 'react';
import Header from "./pages/Header";
import HeroSection from "./pages/HeroSection";
import DownloadSection from './pages/DownloadSection';
import HowItWorksSection from './pages/HowItWorksSection';
import TestimonialsSection from './pages/TestimonialsSection';
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import Footer from './pages/Footer';
import AboutUs from './pages/AboutUs';

function App() {
  const heroSectionRef = useRef<HTMLElement | null>(null);
  const downloadAppRef = useRef<HTMLElement | null>(null);
  const aboutUsRef = useRef<HTMLElement | null>(null);
  const contactDetailsRef = useRef<HTMLElement | null>(null);
  const faqRef = useRef<HTMLElement | null>(null);

  return (
    <>
      <Header
        heroSectionRef={heroSectionRef}
        aboutUsRef={aboutUsRef}
        contactDetailsRef={contactDetailsRef}
        faqRef={faqRef}
      />
      <HeroSection downloadAppRef={downloadAppRef} />
      <AboutUs ref={aboutUsRef} />
      <HowItWorksSection />
      <DownloadSection ref={downloadAppRef} />
      <TestimonialsSection />
      <ContactUs ref={contactDetailsRef} />
      <FAQ ref={faqRef} />
      <Footer
        heroSectionRef={heroSectionRef}
        aboutUsRef={aboutUsRef}
        contactDetailsRef={contactDetailsRef}
        faqRef={faqRef}
      />
    </>
  );
}


export default App;
